import { ENTERPRISE_API_KEY_QUERY_PARAM } from 'multirpc-sdk';
import { t } from '@ankr.com/common';
import { useMemo } from 'react';

import { CopyToClipIcon } from 'uiKit/CopyToClipIcon';
import { shrinkAddress } from 'modules/common/utils/shrinkAddress';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { useEndpointStyles } from './EndpointStyles';

export interface EndpointProps {
  isGRPC?: boolean;
  prefix?: string;
  url: string;
}

const URL_DIVIDER_SYMBOL = '/';
const ENTERPRISE_URL_DIVIDER_SYMBOL = `${ENTERPRISE_API_KEY_QUERY_PARAM}=`;

export const Endpoint = ({ isGRPC, prefix = '', url }: EndpointProps) => {
  const { classes } = useEndpointStyles();

  const { isLoggedIn } = useAuth();

  const textLabel = useMemo(() => {
    if (!isLoggedIn || isGRPC) {
      return url;
    }

    const isEnterpriseEndpoint = url.includes(ENTERPRISE_URL_DIVIDER_SYMBOL);
    const divider = isEnterpriseEndpoint
      ? ENTERPRISE_URL_DIVIDER_SYMBOL
      : URL_DIVIDER_SYMBOL;

    const splittedUrl = url.split(divider);

    return splittedUrl
      .map((value, index) => {
        const lastItemIndex = splittedUrl.length - 1;

        if (index === lastItemIndex) {
          return shrinkAddress(value);
        }

        return value;
      })
      .join(divider);
  }, [isGRPC, isLoggedIn, url]);

  return (
    <CopyToClipIcon
      className={classes.copyToClip}
      contentClassName={classes.copyToClipContent}
      message={t('common.copy-message')}
      size="l"
      text={url}
      textColor="textSecondary"
      textLabel={prefix + textLabel}
    />
  );
};
